import mixpanel from "mixpanel-browser";
import { EventPropertyKeys, EventName } from "../types";

class MixPanel {
  private initialized = false;

  isInitialized() {
    return this.initialized;
  }

  init() {
    try {
      mixpanel.init(String(process.env.REACT_APP_MIXPANEL_TOKEN));
      this.initialized = true;
    } catch (e) {
      this.initialized = false;
      console.error(e);
    }
  }

  track(event: EventName, properties: EventPropertyKeys) {
    try {
      mixpanel.track(event, properties);
    } catch (e) {
      console.error(e);
    }
  }
}

export const MixpanelService = new MixPanel();
